// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { renameGroup as renameGroupApi, RenameGroup } from "@bg/App/Services/WishListService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

interface Props {
    apiParameter: RenameGroup;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = RenameGroup & {
    reloadWishList?: boolean;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        wishListId: props.parameter.wishListId,
        originalGroupName: props.parameter.originalGroupName,
        newGroupName: props.parameter.newGroupName,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    const dataViewParameter = props.getState().pages.myListDetails.loadWishListLinesParameter;
    props.dispatch({
        type: "Data/WishListLines/BeginLoadWishListLines",
        parameter: dataViewParameter,
    });
    props.apiResult = await renameGroupApi(props.apiParameter);
};

export const ReloadWishListOnSuccess: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.reloadWishList) {
        props.dispatch(
            loadWishList({
                wishListId: props.parameter.wishListId,
                exclude: [],
                expand: ["schedule", "sharedUsers"],
            }),
        );
    }
};

export const ReloadWishListLinesOnSuccess: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.reloadWishList) {
        props.dispatch(
            loadWishListLines({
                onSuccess: () => {
                    if (props.apiResult.successful && props.parameter.onComplete) {
                        props.parameter.onComplete(props.apiResult);
                    }
                },
            }),
        );
    }
};

export const CallOnComplete: HandlerType = props => {};

export const chain = [
    DispatchBeginAction,
    CallApiWithParameters,
    ReloadWishListOnSuccess,
    ReloadWishListLinesOnSuccess,
    CallOnComplete,
];

const renameGroup = createHandlerChainRunner(chain, "RenameGroup");
export default renameGroup;
